// Initialize CSP nonce handling
import { getCspNonce, initializeCspNonce } from "@/utils/csp";

import * as Sentry from "@sentry/vue";

import { createApp } from "vue";

import { createPinia } from "pinia";

import PrimeVue from "primevue/config";

import axios from "axios";

import Echo from "laravel-echo";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";

import Pusher from "pusher-js";

import App from "@/App.vue";
import router from "@/router";

import "@/assets/css/app.css";

interface Window {
    Pusher: any;
};

// Initialize CSP nonce
const nonce = getCspNonce();
if (nonce) {
    initializeCspNonce();
}

//@ts-ignore
(window as any).Pusher = Pusher;

// Validate Pusher app key before creating Echo instance
const pusherAppKey = (window as any).PUSHER_APP_KEY;
if (!pusherAppKey || pusherAppKey === '' || pusherAppKey === 'undefined') {
    console.error('PUSHER_APP_KEY is not properly set. Current value:', pusherAppKey);
    console.error('Make sure the PUSHER_APP_KEY environment variable is set in your .env file and the broadcasting configuration is correct.');
    throw new Error('You must pass your app key when you instantiate Pusher. PUSHER_APP_KEY is: ' + pusherAppKey);
}

//@ts-ignore
(window as any).Echo = new Echo({
    broadcaster: "pusher",
    key: pusherAppKey,
    wsHost: window.location.hostname,
    wsPort: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 6001 :
        window.location.hostname === 'portal-dev2.reops.net' ? 443 : 6002,
    wssPort: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 6001 :
        window.location.hostname === 'portal-dev2.reops.net' ? 443 : 6002,
    forceTLS: !(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'),
    disableStats: true,
    enabledTransports: ["ws", "wss"],
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
});

const app = createApp(App, {
    productionTip: true,
});

// Configure CSP nonce for Vue dynamic styles
if (nonce) {
    app.config.globalProperties.$nonce = nonce;
}

app.config.globalProperties.$axios = axios;
app.config.globalProperties.$sentry = Sentry;

Sentry.init({
    app,
    release: import.meta.env.VITE_RELEASE_VERSION,
    dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,
    // replaysSessionSampleRate: 0.2,
    // replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        // Sentry.replayIntegration({
        //     maskAllText: true,
        //     blockAllMedia: true,
        //     networkDetailAllowUrls: [
        //         window.location.origin,
        //         "portal.remoteemployee.com",
        //         "https://portal.remoteemployee.com/api/*",
        //         "https://portal-dev2.reops.net",
        //         "https://portal-dev2.reops.net/api/*",
        //     ],
        // }),
    ],
    // tracesSampleRate: 0.5,
    tracesSampleRate: 0,
    tracePropagationTargets: ["portal.remoteemployee.com", /^\//],
});
app.use(router);
if (nonce) {
    app.use(PrimeVue, {
        csp: {
            nonce: nonce,
        },
    });
} else {
    app.use(PrimeVue);
}
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.mount("#app");
